var _filter, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunctionsFrancisUpperCombBearing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 918 612",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "dropshadow",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.2
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1812,
    height: 22.1999,
    fill: "white",
    transform: "translate(0.109375 1)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-normal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#2D4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#2D4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#2D4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-alert"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#FF0032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#FF0032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#FF0032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 8,
    filter: "url(#dropshadow)",
    id: "default",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "normal"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D4275",
    d: "M8,15.75 C7.01042,15.75 6.05339,15.5612 5.12891,15.1836 C4.20443,14.806 3.39062,14.2591 2.6875,13.543 C1.98438,12.8529 1.44401,12.0456 1.06641,11.1211 C0.688802,10.1966 0.5,9.23958 0.5,8.25 C0.5,7.22135 0.695312,6.2513 1.08594,5.33984 C1.48958,4.42839 2.02995,3.63411 2.70703,2.95703 C3.38411,2.27995 4.17839,1.73958 5.08984,1.33594 C6.0013,0.945312 6.97135,0.75 8,0.75 C9.02865,0.75 9.9987,0.945312 10.9102,1.33594 C11.8216,1.72656 12.6159,2.26693 13.293,2.95703 C13.9831,3.63411 14.5234,4.42839 14.9141,5.33984 C15.3047,6.2513 15.5,7.22135 15.5,8.25 C15.5,9.23958 15.3112,10.1966 14.9336,11.1211 C14.556,12.0456 14.0156,12.8529 13.3125,13.543 C12.6094,14.2591 11.7956,14.806 10.8711,15.1836 C9.94661,15.5612 8.98958,15.75 8,15.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625,7 L8.625,12 L7.375,12 L7.375,7 L8.625,7 Z M8.625,4.5 L8.625,5.75 L7.375,5.75 L7.375,4.5 L8.625,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "normal-highlight"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15D4F1",
    d: "M8,15.75 C7.01042,15.75 6.05339,15.5612 5.12891,15.1836 C4.20443,14.806 3.39062,14.2591 2.6875,13.543 C1.98438,12.8529 1.44401,12.0456 1.06641,11.1211 C0.688802,10.1966 0.5,9.23958 0.5,8.25 C0.5,7.22135 0.695312,6.2513 1.08594,5.33984 C1.48958,4.42839 2.02995,3.63411 2.70703,2.95703 C3.38411,2.27995 4.17839,1.73958 5.08984,1.33594 C6.0013,0.945312 6.97135,0.75 8,0.75 C9.02865,0.75 9.9987,0.945312 10.9102,1.33594 C11.8216,1.72656 12.6159,2.26693 13.293,2.95703 C13.9831,3.63411 14.5234,4.42839 14.9141,5.33984 C15.3047,6.2513 15.5,7.22135 15.5,8.25 C15.5,9.23958 15.3112,10.1966 14.9336,11.1211 C14.556,12.0456 14.0156,12.8529 13.3125,13.543 C12.6094,14.2591 11.7956,14.806 10.8711,15.1836 C9.94661,15.5612 8.98958,15.75 8,15.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625,7 L8.625,12 L7.375,12 L7.375,7 L8.625,7 Z M8.625,4.5 L8.625,5.75 L7.375,5.75 L7.375,4.5 L8.625,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "warning",
    transform: "translate(.317 -.142)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFD200",
    points: "8.883 .75 13.238 8.25 17.555 15.75 .25 15.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.625,12.625 L9.625,13.875 L8.375,13.875 L8.375,12.625 L9.625,12.625 Z M9.625,5.75 L9.625,11.375 L8.375,11.375 L8.375,5.75 L9.625,5.75 Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "alert",
    transform: "translate(.317 -.142)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0032",
    points: "8 .5 15.5 4.836 15.5 13.488 8 17.824 .5 13.488 .5 4.836"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625,12.375 L8.625,13.625 L7.375,13.625 L7.375,12.375 L8.625,12.375 Z M8.625,5.5 L8.625,11.125 L7.375,11.125 L7.375,5.5 L8.625,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    id: "add",
    filter: "url(#dropshadow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M15,7.5 C15,8.5417 14.8047,9.5117 14.4141,10.4102 C14.0234,11.3216 13.4831,12.1224 12.793,12.8125 C12.1159,13.4896 11.3216,14.0234 10.4102,14.4141 C9.5117,14.8047 8.5417,15 7.5,15 C6.4583,15 5.4883,14.8047 4.5898,14.4141 C3.6784,14.0234 2.8776,13.4896 2.1875,12.8125 C1.5104,12.1224 0.9766,11.3216 0.5859,10.4102 C0.1953,9.5117 0,8.5417 0,7.5 C0,6.4583 0.1953,5.4883 0.5859,4.5898 C0.9766,3.67839 1.5104,2.88411 2.1875,2.20703 C2.8776,1.51693 3.6784,0.97656 4.5898,0.58594 C5.4883,0.19531 6.4583,0 7.5,0 C8.5417,0 9.5117,0.19531 10.4102,0.58594 C11.3216,0.97656 12.1159,1.51693 12.793,2.20703 C13.4831,2.88411 14.0234,3.67839 14.4141,4.5898 C14.8047,5.4883 15,6.4583 15,7.5 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "8.004 7.01 10.79 7.01 10.79 8.004 8.004 8.004 8.004 10.888 6.996 10.888 6.996 8.004 4.21 8.004 4.21 7.01 6.996 7.01 6.996 4.112 8.004 4.112"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .malfunction {\n        cursor: pointer;\n      }\n      .group {\n        cursor: pointer;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M679.6 306H325.1C324.466 305.992 323.86 305.737 323.412 305.289C322.963 304.84 322.708 304.234 322.7 303.6V303.6V281.1C322.708 280.466 322.963 279.86 323.412 279.412C323.86 278.963 324.466 278.708 325.1 278.7H454.1C454.734 278.692 455.34 278.437 455.788 277.989C456.237 277.54 456.492 276.934 456.5 276.3V266.9C456.492 266.266 456.237 265.66 455.788 265.212C455.34 264.763 454.734 264.508 454.1 264.5H287.6C286.966 264.492 286.36 264.237 285.912 263.789C285.463 263.34 285.208 262.734 285.2 262.1V254.6C285.208 253.966 285.463 253.36 285.912 252.912C286.36 252.463 286.966 252.208 287.6 252.2H353.3C353.934 252.192 354.54 251.937 354.988 251.489C355.437 251.04 355.692 250.434 355.7 249.8V249.8V211.9C355.692 211.266 355.437 210.66 354.988 210.212C354.54 209.763 353.934 209.508 353.3 209.5H308.8C308.166 209.492 307.56 209.237 307.112 208.789C306.663 208.34 306.408 207.734 306.4 207.1V207.1V172.1C306.392 171.466 306.137 170.86 305.688 170.412C305.24 169.963 304.634 169.708 304 169.7H276.2C275.884 169.704 275.57 169.645 275.277 169.526C274.984 169.406 274.718 169.23 274.494 169.006C274.27 168.782 274.094 168.516 273.974 168.223C273.855 167.93 273.796 167.616 273.8 167.3V167.3V145.8C273.796 145.484 273.855 145.17 273.974 144.877C274.094 144.584 274.27 144.318 274.494 144.094C274.718 143.87 274.984 143.694 275.277 143.575C275.57 143.455 275.884 143.396 276.2 143.4H323.3C323.934 143.392 324.54 143.137 324.988 142.689C325.437 142.24 325.692 141.634 325.7 141V136.5C325.708 135.866 325.963 135.26 326.412 134.812C326.86 134.363 327.466 134.108 328.1 134.1H369.8C370.434 134.108 371.04 134.363 371.488 134.812C371.937 135.26 372.192 135.866 372.2 136.5V136.5V139C372.192 139.634 371.937 140.24 371.488 140.689C371.04 141.137 370.434 141.392 369.8 141.4H364C363.684 141.396 363.37 141.455 363.077 141.575C362.784 141.694 362.518 141.87 362.294 142.094C362.07 142.318 361.894 142.584 361.774 142.877C361.655 143.17 361.596 143.484 361.6 143.8V143.8V145.7C361.608 146.334 361.863 146.94 362.312 147.389C362.76 147.837 363.366 148.092 364 148.1H369.8C370.434 148.108 371.04 148.363 371.488 148.812C371.937 149.26 372.192 149.866 372.2 150.5V153C372.192 153.634 371.937 154.24 371.488 154.689C371.04 155.137 370.434 155.392 369.8 155.4H335.4C335.084 155.396 334.77 155.455 334.477 155.575C334.184 155.694 333.918 155.87 333.694 156.094C333.47 156.318 333.294 156.584 333.174 156.877C333.055 157.17 332.996 157.484 333 157.8V157.8V167.3C332.996 167.616 333.055 167.93 333.174 168.223C333.294 168.516 333.47 168.782 333.694 169.006C333.918 169.23 334.184 169.406 334.477 169.526C334.77 169.645 335.084 169.704 335.4 169.7H466.2C466.516 169.704 466.83 169.645 467.123 169.526C467.416 169.406 467.682 169.23 467.906 169.006C468.13 168.782 468.306 168.516 468.426 168.223C468.545 167.93 468.604 167.616 468.6 167.3V167.3V150.5C468.608 149.866 468.863 149.26 469.312 148.812C469.76 148.363 470.366 148.108 471 148.1H471.8C472.434 148.108 473.04 148.363 473.488 148.812C473.937 149.26 474.192 149.866 474.2 150.5V173.6C474.192 174.234 473.937 174.84 473.488 175.289C473.04 175.737 472.434 175.992 471.8 176H420.8C420.166 176.008 419.56 176.263 419.112 176.712C418.663 177.16 418.408 177.766 418.4 178.4V313.9C418.408 314.534 418.663 315.14 419.112 315.589C419.56 316.037 420.166 316.292 420.8 316.3H679.6",
    stroke: "#DDDDDD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M811.6 436.5H296.8C286.942 436.49 277.344 433.337 269.4 427.5L179.5 360.9L178.9 360.5C186.7 349.7 200.6 340 225.4 337.9C248.8 335.9 262.2 328.4 269.9 319.5L270.3 319.8L314.7 351.5H811.9",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M811.6 436.5H296.8C286.942 436.49 277.344 433.337 269.4 427.5L179.5 360.9L178.9 360.5C186.7 349.7 200.6 340 225.4 337.9C248.8 335.9 262.2 328.4 269.9 319.5L270.3 319.8L314.7 351.5H811.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M366.6 162.5C376.486 162.5 384.5 154.486 384.5 144.6C384.5 134.714 376.486 126.7 366.6 126.7C356.714 126.7 348.7 134.714 348.7 144.6C348.7 154.486 356.714 162.5 366.6 162.5Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M630.6 327.6H750.8C751.116 327.596 751.43 327.655 751.723 327.774C752.016 327.893 752.282 328.07 752.506 328.294C752.729 328.517 752.906 328.784 753.025 329.077C753.144 329.37 753.204 329.684 753.2 330V330V379.1",
    stroke: "#6F6F6F",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M620.1 285.9H628.2C628.834 285.908 629.44 286.163 629.888 286.611C630.336 287.06 630.592 287.666 630.6 288.3V379.1",
    stroke: "#6F6F6F",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 142.5H0V351.6H42.8V142.5Z",
    fill: "#DDDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 67.2002V214.7H108.3C117.912 214.696 127.285 217.704 135.1 223.3L247.2 303.5C239.4 312.2 226 319.5 203 321.5C178.4 323.6 164.5 333.2 156.7 343.9L156.6 344L116.3 314.2H42.3V351.5H0",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2998 67.2002V214.7H108.3C117.912 214.696 127.284 217.704 135.1 223.3L247.2 303.5C239.4 312.2 226 319.5 203 321.5C178.4 323.6 164.5 333.2 156.7 343.9L156.6 344L116.3 314.2H42.2998V351.5",
    fill: "#DDDDDD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2998 67.2002V214.7H108.3C117.912 214.696 127.284 217.704 135.1 223.3L247.2 303.5C239.4 312.2 226 319.5 203 321.5C178.4 323.6 164.5 333.2 156.7 343.9L156.6 344L116.3 314.2H42.2998V351.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.1 394C169.1 394 164.5 343.1 225.3 337.9C289.9 332.3 278.9 284.2 278.9 284.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 377.8C146.9 377.8 142.3 326.9 203.1 321.6C267.7 316 256.8 267.9 256.8 267.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M702.4 58.5998H750.4C750.717 58.5958 751.031 58.6551 751.324 58.7743C751.617 58.8935 751.883 59.0701 752.106 59.2938C752.33 59.5174 752.507 59.7836 752.626 60.0766C752.745 60.3696 752.804 60.6835 752.8 60.9998V79.4998C752.793 80.1339 752.537 80.7398 752.089 81.1883C751.64 81.6367 751.034 81.892 750.4 81.8998H729.8C729.166 81.9076 728.56 82.1629 728.112 82.6114C727.664 83.0598 727.408 83.6657 727.4 84.2998V88.2998C727.408 88.9339 727.664 89.5398 728.112 89.9883C728.56 90.4367 729.166 90.692 729.8 90.6998H750.4C751.034 90.7076 751.64 90.9629 752.089 91.4113C752.537 91.8598 752.793 92.4657 752.8 93.0998V228.1C752.793 228.734 752.537 229.34 752.089 229.788C751.64 230.237 751.034 230.492 750.4 230.5H727.2C726.566 230.508 725.96 230.763 725.512 231.211C725.063 231.66 724.808 232.266 724.8 232.9V247.9C724.8 249.2 723.7 251.1 722.4 251.1H717.5C716.866 251.108 716.26 251.363 715.812 251.811C715.363 252.26 715.108 252.866 715.1 253.5V266C715.108 266.634 715.363 267.24 715.812 267.688C716.26 268.137 716.866 268.392 717.5 268.4H760.2C760.834 268.408 761.44 268.663 761.889 269.111C762.337 269.56 762.593 270.166 762.6 270.8V288.2C762.593 288.834 762.337 289.44 761.889 289.888C761.44 290.337 760.834 290.592 760.2 290.6H717.4C716.766 290.608 716.16 290.863 715.712 291.311C715.264 291.76 715.008 292.366 715 293V293.5C715.008 294.134 715.264 294.74 715.712 295.188C716.16 295.637 716.766 295.892 717.4 295.9H724.6C725.234 295.908 725.84 296.163 726.289 296.611C726.737 297.06 726.993 297.666 727 298.3C726.993 298.934 726.737 299.54 726.289 299.988C725.84 300.437 725.234 300.692 724.6 300.7H717.3C716.666 300.708 716.06 300.963 715.612 301.411C715.164 301.86 714.908 302.466 714.9 303.1V306C714.908 306.634 715.164 307.24 715.612 307.688C716.06 308.137 716.666 308.392 717.3 308.4H729.4C730.034 308.408 730.64 308.663 731.089 309.111C731.537 309.56 731.793 310.166 731.8 310.8V360.2C731.793 360.834 731.537 361.44 731.089 361.888C730.64 362.337 730.034 362.592 729.4 362.6H723.8C723.166 362.608 722.56 362.863 722.112 363.311C721.664 363.76 721.408 364.366 721.4 365V373.8",
    stroke: "#EDEDED",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M726.5 381.8H770.4L770.5 406.4C770.5 406.4 744 407.2 739 425L726.5 381.8Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M644.1 425.1C640.2 407.2 615.6 406.2 612.6 406.5L612.7 381.9H658.2L644.1 425.1",
    fill: "#9C9C9C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M644.1 425.1C640.2 407.2 615.6 406.2 612.6 406.5L612.7 381.9H658.2L644.1 425.1",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M739 425.1L750.8 516.3H632.2L644 425.1",
    fill: "#F6F6F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M739 425.1L750.8 516.3H632.2L644 425.1",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5 223.2H756.2V302.2H778.5V223.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M800.9 223.2H778.6V302.2H800.9V223.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 236.7H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 241H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 245.4H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 249.7H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M778.6 262.8H801",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M823.3 223.2H801V302.2H823.3V223.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 236.7H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 241H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 245.4H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 249.7H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M801 262.8H823.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M845.6 223.2H823.3V302.2H845.6V223.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M828 236.7H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M828 241H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M828 245.4H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M828 249.7H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M823.3 262.8H845.7",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M868 223.2H845.7V302.2H868V223.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 236.7H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 241H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 245.4H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 249.7H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 275.7H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 280H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 284.4H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 288.7H796.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M761 236.7H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M761 241H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M761 245.4H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M761 249.7H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M756.2 262.8H778.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M761 275.7H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M761 280H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M761 284.4H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M761 288.7H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 275.7H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 280H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 284.4H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M805.7 288.7H818.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M828 275.7H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M828 280H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M828 284.4H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M828 288.7H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 275.7H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 280H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 284.4H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4 288.7H863.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M845.7 262.8H868",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M890.3 223.2H868V302.2H890.3V223.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 236.7H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 241H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 245.4H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 249.7H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 275.7H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 280H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 284.4H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M872.7 288.7H885.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M868 262.8H890.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M654.8 381.8H728",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M671 338.1H663.8V358.2H671V338.1Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M719 338.1H711.8V358.2H719V338.1Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M708.1 338.1H674.5V363.2H708.1V338.1Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M703 90H680V338H703V90Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M703.2 363.2H679.6V373.8H703.2V363.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M718.1 71.7998H664.5V97.5998H718.1V71.7998Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M661 76.7998H653.8V96.8998H661V76.7998Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M729 76.7998H721.8V96.8998H729V76.7998Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M710.3 65.2998H672.4V71.7998H710.3V65.2998Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M708.1 136.6H674.5V144.6H708.1V136.6Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M632.2 516.3C632.082 537.774 639.197 558.663 652.4 575.6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M810.8 436.6C834.162 436.6 853.1 417.572 853.1 394.1C853.1 370.628 834.162 351.6 810.8 351.6C787.438 351.6 768.5 370.628 768.5 394.1C768.5 417.572 787.438 436.6 810.8 436.6Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M750.7 516.3C751.116 518.539 752.401 520.522 754.276 521.815C756.15 523.108 758.46 523.606 760.7 523.2",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M708.1 214.5H674.5V221H708.1V214.5Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M661 220.9H653.8V241H661V220.9Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M729 220.9H721.8V241H729V220.9Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M718.1 220.9H664.5V241H718.1V220.9Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M824.4 144H559.3V214.4H824.4V144Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 151.4H564.8V207H569.5V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M580.8 151.4H573.6V207H580.8V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M594.8 151.4H585V207H594.8V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M611.3 151.4H599V207H611.3V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M630.3 151.4H615.5V207H630.3V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M651.9 151.4H634.5V207H651.9V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M676 151.4H656.1V207H676V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M702.6 151.4H680.2V207H702.6V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M818.3 151.4H813.6V207H818.3V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M809.4 151.4H802.2V207H809.4V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M798 151.4H788.2V207H798V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M784 151.4H771.7V207H784V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M767.5 151.4H752.7V207H767.5V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6 151.4H731.2V207H748.6V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M727 151.4H707.1V207H727V151.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M703.2 51.6001H679.6V65.4001H703.2V51.6001Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M694.3 39H688.6V51.6H694.3V39Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M511.8 231.8H513.4C514.939 231.8 516.414 232.411 517.502 233.499C518.589 234.586 519.2 236.062 519.2 237.6V237.6V285.2C519.2 285.943 518.905 286.655 518.38 287.18C517.855 287.705 517.143 288 516.4 288H508.9C508.158 288 507.446 287.705 506.92 287.18C506.395 286.655 506.1 285.943 506.1 285.2V237.6C506.082 236.842 506.215 236.087 506.494 235.382C506.772 234.676 507.19 234.034 507.722 233.493C508.253 232.951 508.889 232.523 509.589 232.232C510.29 231.941 511.042 231.794 511.8 231.8V231.8Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M547 235.2C547.972 235.198 548.936 235.387 549.835 235.758C550.734 236.129 551.55 236.674 552.238 237.362C552.926 238.049 553.471 238.866 553.842 239.765C554.213 240.664 554.402 241.628 554.4 242.6V242.6V257C554.402 257.973 554.213 258.936 553.842 259.835C553.471 260.734 552.926 261.551 552.238 262.239C551.55 262.926 550.734 263.471 549.835 263.842C548.936 264.213 547.972 264.403 547 264.4V264.4C546.027 264.403 545.064 264.213 544.165 263.842C543.266 263.471 542.449 262.926 541.761 262.239C541.074 261.551 540.529 260.734 540.158 259.835C539.787 258.936 539.597 257.973 539.6 257V242.7C539.592 240.726 540.366 238.829 541.752 237.423C543.139 236.018 545.025 235.219 547 235.2V235.2Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M542.8 247.1V258.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M545.6 247.8V259.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 247.8V259.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M551.3 247.1V258.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M566.7 235.2C567.672 235.198 568.636 235.387 569.535 235.758C570.434 236.129 571.251 236.674 571.938 237.362C572.626 238.049 573.171 238.866 573.542 239.765C573.913 240.664 574.102 241.628 574.1 242.6V257C574.102 257.973 573.913 258.936 573.542 259.835C573.171 260.734 572.626 261.551 571.938 262.239C571.251 262.926 570.434 263.471 569.535 263.842C568.636 264.213 567.672 264.403 566.7 264.4V264.4C565.727 264.403 564.764 264.213 563.865 263.842C562.966 263.471 562.149 262.926 561.461 262.239C560.774 261.551 560.229 260.734 559.858 259.835C559.487 258.936 559.297 257.973 559.3 257V257V242.7C559.292 240.726 560.066 238.829 561.452 237.423C562.839 236.018 564.726 235.219 566.7 235.2V235.2Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M562.5 247.1V258.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M565.3 247.8V259.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M568.1 247.8V259.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M571 247.1V258.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M626.1 258.9H520.4V290.6H626.1V258.9Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M533.9 216.2H520.4V239.1H533.9V216.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M520.4 230.8L512.6 283.5H520.4V230.8Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M512.6 222.3C513.234 222.308 513.84 222.563 514.289 223.012C514.737 223.46 514.992 224.066 515 224.7V229.4C514.992 230.034 514.737 230.64 514.289 231.089C513.84 231.537 513.234 231.792 512.6 231.8V231.8C511.966 231.792 511.36 231.537 510.912 231.089C510.463 230.64 510.208 230.034 510.2 229.4V229.4V224.7C510.187 224.382 510.241 224.064 510.357 223.767C510.473 223.47 510.649 223.2 510.875 222.975C511.1 222.749 511.37 222.573 511.667 222.457C511.964 222.341 512.281 222.287 512.6 222.3V222.3Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M527.1 264.5V285.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M600.9 249.1H599.5V258.9H600.9V249.1Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 249.8C602.819 249.8 604.7 247.92 604.7 245.6C604.7 243.28 602.819 241.4 600.5 241.4C598.18 241.4 596.3 243.28 596.3 245.6C596.3 247.92 598.18 249.8 600.5 249.8Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M599.2 246.4L600.5 245.6",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M530.2 239.3C530.261 240.1 530.013 240.892 529.506 241.514C529 242.135 528.275 242.539 527.48 242.642C526.684 242.744 525.88 242.538 525.233 242.065C524.585 241.592 524.144 240.889 524 240.1V239.2L530.2 239.3Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M527.1 242.8V249.4C527.112 250.917 527.714 252.37 528.777 253.452C529.841 254.534 531.283 255.161 532.8 255.2V255.2C534.111 255.18 535.378 254.722 536.4 253.9L539.5 251.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M590.8 244.7H588V252.1H590.8V244.7Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M586.6 241.4H589.4C589.704 241.394 590.005 241.45 590.287 241.564C590.568 241.677 590.824 241.847 591.039 242.061C591.253 242.276 591.422 242.532 591.536 242.813C591.65 243.095 591.706 243.396 591.7 243.7V243.7C591.706 244.003 591.65 244.305 591.536 244.586C591.422 244.868 591.253 245.124 591.039 245.338C590.824 245.553 590.568 245.722 590.287 245.836C590.005 245.949 589.704 246.005 589.4 246H586.6C586.297 246.005 585.995 245.949 585.714 245.836C585.432 245.722 585.176 245.553 584.962 245.338C584.747 245.124 584.578 244.868 584.464 244.586C584.351 244.305 584.295 244.003 584.3 243.7V243.7C584.295 243.396 584.351 243.095 584.464 242.813C584.578 242.532 584.747 242.276 584.962 242.061C585.176 241.847 585.432 241.677 585.714 241.564C585.995 241.45 586.297 241.394 586.6 241.4V241.4Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M621.3 253.6H613.6V258.7H621.3V253.6Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M617.4 255.4C620.935 255.4 623.8 252.535 623.8 249C623.8 245.465 620.935 242.6 617.4 242.6C613.865 242.6 611 245.465 611 249C611 252.535 613.865 255.4 617.4 255.4Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M527.6 290.7H520.4V295.2H527.6V290.7Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M626.1 290.7H618.9V295.2H626.1V290.7Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M543.9 281.1C547.214 281.1 549.9 278.414 549.9 275.1C549.9 271.786 547.214 269.1 543.9 269.1C540.587 269.1 537.9 271.786 537.9 275.1C537.9 278.414 540.587 281.1 543.9 281.1Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M565.9 281.1C569.214 281.1 571.9 278.414 571.9 275.1C571.9 271.786 569.214 269.1 565.9 269.1C562.587 269.1 559.9 271.786 559.9 275.1C559.9 278.414 562.587 281.1 565.9 281.1Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M587.8 281.1C591.114 281.1 593.8 278.414 593.8 275.1C593.8 271.786 591.114 269.1 587.8 269.1C584.486 269.1 581.8 271.786 581.8 275.1C581.8 278.414 584.486 281.1 587.8 281.1Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M609.8 281.1C613.114 281.1 615.8 278.414 615.8 275.1C615.8 271.786 613.114 269.1 609.8 269.1C606.486 269.1 603.8 271.786 603.8 275.1C603.8 278.414 606.486 281.1 609.8 281.1Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M583.4 243.7C582.127 243.7 580.906 244.206 580.005 245.106C579.105 246.006 578.6 247.227 578.6 248.5V248.5V258.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M607.9 253.3H582.5V258.8H607.9V253.3Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M675.6 126.2H656.3V131.9H675.6V126.2Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M721.8 113.3H661V122.6H721.8V113.3Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M726.4 126.2H707.1V131.9H726.4V126.2Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M718.1 104H664.5V113.3H718.1V104Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M589 420.5C603.58 420.5 615.4 408.636 615.4 394C615.4 379.364 603.58 367.5 589 367.5C574.419 367.5 562.6 379.364 562.6 394C562.6 408.636 574.419 420.5 589 420.5Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M727.6 373.9H655.1V381.8H727.6V373.9Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M727.6 381.8C727.6 381.8 728.8 397 738.9 406.4V425.1H643.8V406.4C654 397 655.1 381.8 655.1 381.8H727.6Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M669.9 381.8C669.9 381.8 669.1 397 662.6 406.4Z",
    fill: "#DDDDDD"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M669.9 381.8C669.9 381.8 669.1 397 662.6 406.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M712.8 381.8C712.8 381.8 713.6 397 720.1 406.4Z",
    fill: "#DDDDDD"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M712.8 381.8C712.8 381.8 713.6 397 720.1 406.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 381.8C685.5 381.8 685 397 680.5 406.4Z",
    fill: "#DDDDDD"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 381.8C685.5 381.8 685 397 680.5 406.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M697.3 381.8C697.3 381.8 697.8 397 702.2 406.4Z",
    fill: "#DDDDDD"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M697.3 381.8C697.3 381.8 697.8 397 702.2 406.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M739 406.4H643.8V425.1H739V406.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M614.6 406.4H643.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M739 406.4H770.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M640.2 403.9H620.5V406.1H640.2V403.9Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M640.2 381.8H620.5V384H640.2V381.8Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M762.8 403.9H743.1V406.1H762.8V403.9Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M762.8 381.9H743.1V384.1H762.8V381.9Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M746.3 379.9H759.7V409.3L746.3 415.3V379.9Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M637.3 402.6V415.3L623.9 409.3V379.9H637.3V402.6Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 314.3V313.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 311.2V303.9",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeDasharray: "2.08 2.08 2.08 2.08"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 302.9V216.7",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeDasharray: "2.08 2.08 2.08 2.08 2.08 2.08"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 215.7V214.7",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6 238.4V323.9H57.5V146H68.6V238.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5004 238.4V323.9H81.4004V146H92.5004V238.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 142.4H0",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M458.6 228.5H455.8V253.5H458.6V228.5Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M457.2 225.2H466.9C467.203 225.195 467.505 225.25 467.786 225.364C468.068 225.478 468.324 225.647 468.538 225.862C468.753 226.076 468.922 226.332 469.036 226.614C469.149 226.895 469.205 227.197 469.2 227.5V227.5C469.205 227.804 469.149 228.105 469.036 228.387C468.922 228.668 468.753 228.924 468.538 229.138C468.324 229.353 468.068 229.522 467.786 229.636C467.505 229.75 467.203 229.805 466.9 229.8H457.2C456.896 229.805 456.595 229.75 456.313 229.636C456.032 229.522 455.776 229.353 455.561 229.138C455.347 228.924 455.177 228.668 455.064 228.387C454.95 228.105 454.894 227.804 454.9 227.5C454.894 227.197 454.95 226.895 455.064 226.614C455.177 226.332 455.347 226.076 455.561 225.862C455.776 225.647 456.032 225.478 456.313 225.364C456.595 225.25 456.896 225.195 457.2 225.2Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M384.7 251.8H453.2C457.84 251.805 462.288 253.651 465.569 256.931C468.849 260.212 470.695 264.66 470.7 269.3V273.8C470.695 278.439 468.849 282.888 465.569 286.168C462.288 289.449 457.84 291.294 453.2 291.3H384.7C380.061 291.294 375.612 289.449 372.332 286.168C369.051 282.888 367.205 278.439 367.2 273.8V269.3C367.205 264.66 369.051 260.212 372.332 256.931C375.612 253.651 380.061 251.805 384.7 251.8V251.8Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M405.4 247.6H388.1L388.9 243.3H404.5L405.4 247.6Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M429.4 248.1H386.6V251.8H429.4V248.1Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M434 251.7C433.924 251.282 433.933 250.853 434.028 250.439C434.123 250.025 434.301 249.634 434.552 249.291C434.802 248.948 435.12 248.66 435.486 248.443C435.851 248.227 436.257 248.087 436.679 248.033C437.1 247.979 437.528 248.011 437.937 248.127C438.345 248.243 438.726 248.442 439.055 248.71C439.385 248.978 439.656 249.311 439.853 249.687C440.05 250.064 440.168 250.476 440.2 250.9V250.9V251.7H434Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M437.1 245.5H441.1C441.429 245.502 441.755 245.44 442.059 245.315C442.364 245.19 442.641 245.006 442.873 244.774C443.106 244.541 443.29 244.264 443.415 243.96C443.539 243.655 443.602 243.329 443.6 243V243V239.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M390.7 291.3H383.5V295.8H390.7V291.3Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5 291.3H447.3V295.8H454.5V291.3Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M447.7 241.6H446.3V251.4H447.7V241.6Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M447.3 242.3C449.619 242.3 451.5 240.42 451.5 238.1C451.5 235.78 449.619 233.9 447.3 233.9C444.98 233.9 443.1 235.78 443.1 238.1C443.1 240.42 444.98 242.3 447.3 242.3Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M446 238.9L447.3 238.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M375.8 235.5C375.797 234.528 375.987 233.564 376.358 232.665C376.729 231.766 377.274 230.949 377.961 230.262C378.649 229.574 379.466 229.029 380.365 228.658C381.264 228.287 382.227 228.097 383.2 228.1H407.3C408.272 228.097 409.236 228.287 410.135 228.658C411.034 229.029 411.851 229.574 412.538 230.262C413.226 230.949 413.771 231.766 414.142 232.665C414.513 233.564 414.702 234.528 414.7 235.5V235.5C414.702 236.473 414.513 237.436 414.142 238.335C413.771 239.234 413.226 240.051 412.538 240.739C411.851 241.426 411.034 241.971 410.135 242.342C409.236 242.713 408.272 242.903 407.3 242.9H383.2C381.241 242.887 379.367 242.103 377.982 240.718C376.597 239.333 375.813 237.459 375.8 235.5V235.5Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M386.6 239.7H409.1",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 236.9H410.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 234.1H410.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M386.6 231.2H409.1",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M377.5 225.9H380.6C381.608 225.9 382.575 226.3 383.287 227.013C384 227.726 384.4 228.692 384.4 229.7V241.4C384.4 242.408 384 243.374 383.287 244.087C382.575 244.8 381.608 245.2 380.6 245.2H377.5C376.492 245.2 375.526 244.8 374.813 244.087C374.101 243.374 373.7 242.408 373.7 241.4V229.7C373.7 228.692 374.101 227.726 374.813 227.013C375.526 226.3 376.492 225.9 377.5 225.9V225.9Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M407.5 206.8H427.6C427.824 206.799 428.045 206.842 428.252 206.927C428.459 207.011 428.647 207.137 428.805 207.295C428.963 207.453 429.088 207.641 429.173 207.848C429.258 208.055 429.301 208.276 429.3 208.5C429.301 208.723 429.258 208.945 429.173 209.152C429.088 209.359 428.963 209.547 428.805 209.705C428.647 209.863 428.459 209.988 428.252 210.073C428.045 210.158 427.824 210.201 427.6 210.2H407.5V206.8V206.8Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M425.4 226.3H411.4L410.4 213.7H426.4L425.4 226.3Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M411.4 206.2H425.4L426.4 213.3H410.4L411.4 206.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M405.9 203.9C406.203 203.894 406.505 203.95 406.787 204.064C407.068 204.177 407.324 204.347 407.538 204.561C407.753 204.776 407.922 205.032 408.036 205.313C408.15 205.595 408.205 205.896 408.2 206.2V211.4C408.205 211.703 408.15 212.005 408.036 212.286C407.922 212.568 407.753 212.824 407.538 213.038C407.324 213.253 407.068 213.422 406.787 213.536C406.505 213.649 406.203 213.705 405.9 213.7V213.7C405.596 213.705 405.295 213.649 405.013 213.536C404.732 213.422 404.476 213.253 404.262 213.038C404.047 212.824 403.878 212.568 403.764 212.286C403.65 212.005 403.595 211.703 403.6 211.4V206.2C403.608 205.592 403.853 205.012 404.282 204.582C404.712 204.152 405.292 203.908 405.9 203.9V203.9Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M428.6 248.1H408.1L409.1 225.8H427.6L428.6 248.1Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M429.3 208.5H434.6C434.929 208.497 435.255 208.56 435.56 208.685C435.864 208.81 436.141 208.994 436.374 209.226C436.606 209.459 436.79 209.736 436.915 210.04C437.04 210.345 437.102 210.671 437.1 211V251.8",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M484.2 160.2H457.4L458.7 153.6H482.9L484.2 160.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9 129.9H487.3C490.35 129.9 493.275 131.112 495.431 133.268C497.588 135.425 498.8 138.35 498.8 141.4V141.4C498.8 144.45 497.588 147.375 495.431 149.532C493.275 151.688 490.35 152.9 487.3 152.9H449.9C446.85 152.9 443.925 151.688 441.768 149.532C439.611 147.375 438.4 144.45 438.4 141.4C438.392 139.888 438.684 138.389 439.259 136.99C439.834 135.591 440.681 134.32 441.75 133.251C442.82 132.181 444.09 131.334 445.489 130.759C446.888 130.184 448.387 129.892 449.9 129.9V129.9Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M455 148H489.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M456.4 143.6H491.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M456.4 139.2H491.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M455 134.8H489.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M441 126.5H445.9C446.676 126.494 447.447 126.642 448.166 126.936C448.884 127.23 449.537 127.664 450.087 128.213C450.636 128.763 451.07 129.416 451.364 130.135C451.658 130.853 451.806 131.624 451.8 132.4V150.5C451.806 151.277 451.658 152.047 451.364 152.766C451.07 153.485 450.636 154.138 450.087 154.687C449.537 155.236 448.884 155.671 448.166 155.965C447.447 156.259 446.676 156.407 445.9 156.4H441C440.223 156.407 439.453 156.259 438.734 155.965C438.015 155.671 437.362 155.236 436.813 154.687C436.264 154.138 435.829 153.485 435.535 152.766C435.241 152.047 435.093 151.277 435.1 150.5V132.4C435.093 131.624 435.241 130.853 435.535 130.135C435.829 129.416 436.264 128.763 436.813 128.213C437.362 127.664 438.015 127.23 438.734 126.936C439.453 126.642 440.223 126.494 441 126.5V126.5Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M352 134H369.7C370.334 134.008 370.94 134.263 371.388 134.712C371.837 135.16 372.092 135.766 372.1 136.4V136.4V138.9C372.092 139.534 371.837 140.14 371.388 140.588C370.94 141.037 370.334 141.292 369.7 141.3H363.9C363.584 141.296 363.27 141.355 362.977 141.474C362.684 141.594 362.418 141.77 362.194 141.994C361.97 142.218 361.794 142.484 361.674 142.777C361.555 143.07 361.496 143.384 361.5 143.7V143.7V145.6C361.508 146.234 361.763 146.84 362.212 147.288C362.66 147.737 363.266 147.992 363.9 148H369.7C370.334 148.008 370.94 148.263 371.388 148.712C371.837 149.16 372.092 149.766 372.1 150.4V150.4V152.9C372.092 153.534 371.837 154.14 371.388 154.588C370.94 155.037 370.334 155.292 369.7 155.3H352.5",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M366.6 162.5C376.486 162.5 384.5 154.486 384.5 144.6C384.5 134.714 376.486 126.7 366.6 126.7C356.714 126.7 348.7 134.714 348.7 144.6C348.7 154.486 356.714 162.5 366.6 162.5Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M128.9 34C166.6 96.7 209.6 87.1 216.2 87.8",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M120.6 59.8999C143.2 97.1999 179.4 98.2999 190.7 95.8999",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 192.4H257.8C257.062 192.385 256.359 192.085 255.837 191.563C255.315 191.041 255.016 190.338 255 189.6V113.4C255.007 112.722 254.768 112.064 254.326 111.549C253.885 111.034 253.272 110.697 252.6 110.6C245.6 109.5 225 105 216.2 87.7002",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M239.05 183.13H165.25V186.93H239.05V183.13Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M241.75 186.95H162.45V203.25H241.75V186.95Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 183.2C225.895 183.2 228 181.096 228 178.5C228 175.904 225.895 173.8 223.3 173.8C220.704 173.8 218.6 175.904 218.6 178.5C218.6 181.096 220.704 183.2 223.3 183.2Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2 183.2C213.796 183.2 215.9 181.096 215.9 178.5C215.9 175.904 213.796 173.8 211.2 173.8C208.604 173.8 206.5 175.904 206.5 178.5C206.5 181.096 208.604 183.2 211.2 183.2Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M193.2 183.2C195.796 183.2 197.9 181.096 197.9 178.5C197.9 175.904 195.796 173.8 193.2 173.8C190.604 173.8 188.5 175.904 188.5 178.5C188.5 181.096 190.604 183.2 193.2 183.2Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M181.1 183.2C183.696 183.2 185.8 181.096 185.8 178.5C185.8 175.904 183.696 173.8 181.1 173.8C178.505 173.8 176.4 175.904 176.4 178.5C176.4 181.096 178.505 183.2 181.1 183.2Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M223.08 115.38H180.88V173.78H223.08V115.38Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M234.09 165.08H223.29V169.18H234.09V165.08Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M223.1 161.8H234.1V133L223.1 116V161.8Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M181 165.1H170.2V169.2H181V165.1Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M181 161.8H170.2V133L181 116V161.8Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M223.08 111.05H180.88V115.35H223.08V111.05Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M216.39 86.9302H214.59V111.13H216.39V86.9302Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M215.4 104.2C216.196 104.2 216.959 103.884 217.522 103.321C218.084 102.759 218.4 101.996 218.4 101.2V92C218.4 91.2044 218.084 90.4413 217.522 89.8787C216.959 89.3161 216.196 89 215.4 89V89C214.605 89 213.842 89.3161 213.279 89.8787C212.716 90.4413 212.4 91.2044 212.4 92V101.2C212.421 101.989 212.743 102.741 213.301 103.299C213.86 103.857 214.611 104.18 215.4 104.2V104.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M189.72 95.4102H187.92V110.81H189.72V95.4102Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M188.8 107.1C189.595 107.1 190.359 106.784 190.921 106.221C191.484 105.659 191.8 104.896 191.8 104.1V100.4C191.8 99.6043 191.484 98.8412 190.921 98.2786C190.359 97.716 189.595 97.3999 188.8 97.3999V97.3999C188.004 97.3999 187.241 97.716 186.678 98.2786C186.116 98.8412 185.8 99.6043 185.8 100.4V104.1C185.8 104.896 186.116 105.659 186.678 106.221C187.241 106.784 188.004 107.1 188.8 107.1Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "malfunctions"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunctionsFrancisUpperCombBearing);
export default __webpack_public_path__ + "static/media/malfunctions_francis-upper-comb-bearing.6e0c90f00335a524675892add667abce.svg";
export { ForwardRef as ReactComponent };